export default __webpack_public_path__ + "static/13-a9a7ab87ed708acdc421f8c9714e2ffb.jpg";